import Query from '../utils/Query';

const defaultFields = '*,created_by.*,created_by.avatar.private_hash';

export default class StrategyService {

	static getAll(id) {
		return Query.get('/items/strategy' + (id ? '?filter[created_by]=' + id + '&fields=' + defaultFields : ''));
	}

	static get(id, revisionOffset) {
		return Query.get('/items/strategy/' + id + (revisionOffset !== undefined ? '/revisions/' + revisionOffset : ''));
	}

	static getRevisions(id) {
		return Query.get('/items/strategy/' + id + '/revisions?limit=25&fields=*,activity.action_by.first_name,activity.action_by.last_name,activity.action_by.screen_name,activity.action_by.avatar.private_hash');
	}

	static save(id, data) {
		if (id) {
			return Query.patch('/items/strategy/' + id, data);
		} else {
			return Query.post('/items/strategy', data);
		}
	}

	static remove(id) {
		return Query.delete('/items/strategy/' + id);
	}

	static restore(id) {
		return Query.patch('/items/strategy/' + id, {
			status: 'draft'
		});
	}
}
